export default {
  type: 'doc',
  content: [
    {
      type: 'table',
      attrs: { layout: 'default' },
      content: [
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Environments I like to work in',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [
                {
                  type: 'bulletList',
                  content: [
                    {
                      type: 'listItem',
                      content: [
                        {
                          type: 'paragraph',
                          content: [
                            {
                              type: 'placeholder',
                              attrs: {
                                text: 'Use bullets to describe your preferences for each category.'
                              }
                            },
                            { text: ' ', type: 'text' }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'placeholder',
                      attrs: {
                        text: 'Add images in this column whenever relevant, or just to inject some fun!'
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Preferred working hours',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Communication preferences',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Preferred ways to receive feedback',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Things I need',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'How I learn best',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Things I struggle with',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Things I love',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'If I were an animated gif/meme/animal/song, I would be...',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'My favorite saying',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Other things I want you to know about me',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'placeholder',
                      attrs: { text: 'Add your own categories' }
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [224.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            }
          ]
        }
      ]
    },
    {
      type: 'panel',
      attrs: { panelType: 'info' },
      content: [
        {
          type: 'paragraph',
          content: [
            {
              text: 'For a facilitation guide and more info on running this play with your team, visit',
              type: 'text'
            },
            {
              text: ' https://www.atlassian.com/team-playbook/plays/my-user-manual',
              type: 'text',
              marks: [
                {
                  type: 'link',
                  attrs: {
                    href: 'https://www.atlassian.com/team-playbook/plays/my-user-manual'
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  version: 1
};
